import { Rule } from 'antd/es/form'
import { yupSyncGenerator } from 'src/common/helpers'
import * as yup from 'yup'

const schema = yup.object({
  select_existing_care_partner: yup.string(),
})

export const yupSync: Rule = yupSyncGenerator(schema)
